import { ReactNode } from 'react'
import { Text } from '@audio-network/componentlibrary'

type Props = {
	children?: ReactNode
}

export default function ToastBold({ children }: Props): JSX.Element {
	return (
		<Text variant="headingXS" style={{ fontSize: '1rem' }}>
			{children}
		</Text>
	)
}
